import { COMMERCIAL_BILLING_NAV_KEYS } from '@/components/SiderMenu/utils/sessionNavigation';

/** DVA namespace — must match `model.js` and route registration. */
export const MODEL_NAME = 'channelRegistrationApprovals';

/**
 * Descriptor-only route token (export/tasks disabled).
 * Runtime list/detail base path comes from session navigation (commercial billing).
 */
export const FETCH_ROUTE = 'channel-registration-approvals';

/**
 * Documented API path when GET /me/navigation has not emitted `registration-approvals`.
 * Fallback menu for Automy owner still needs a fetch base.
 */
export const FALLBACK_API_ROUTE = 'channel/registration-approvals';

/** Singular entity name for shared helpers / notifications. */
export const ENTITY_NAME = 'channelRegistrationApproval';

/** i18n resource key for form drawer hero summary (`configForm.hero.summary.resource.{key}.*`). */
export const FORM_RESOURCE_KEY = 'channelRegistrationApprovals';

/** Default OData sort when the user clears column sorting. */
export const DEFAULT_ORDER_BY = 'requestedAt desc';

/** Session navigation key used to resolve the commercial billing API base path. */
export const NAVIGATION_KEY = COMMERCIAL_BILLING_NAV_KEYS.REGISTRATION_APPROVALS;

export const CHANNEL_REGISTRATION_APPROVALS_PATH = '/configuration/channel-registration-approvals';

/** Automy-owner review actions — POST `/{id}/approve` | `/{id}/reject`. */
export const REGISTRATION_REVIEW_ACTION = Object.freeze({
  APPROVE: 'approve',
  REJECT: 'reject',
});
